module.exports = __webpack_public_path__ + "img/discounts-unactive.148fa47.svg";